import Spinner from 'react-bootstrap/Spinner';
import {Modal, Row, Col,Button, Card, Form} from 'react-bootstrap'
import DataTable from  '../DataTable/DataTable';
import { useEffect, useState,useRef } from 'react';
import { Navigate } from "react-router-dom";
import Layout from '../../layout/default';
import { Icon, CustomDropdownToggle, CustomDropdownMenu, LinkList, LinkListItem, Rating } from "../../components";
import { Block,BlockHead, BlockHeadBetween, BlockHeadContent} from '../../components';
import { Alert } from 'react-bootstrap';
import { useApiClient } from '../../ApiService/useApiClient';

const baseURL = "HMCareSettings/productlist/";

const pagetitle = "Services";
const pagetitleAddNew = "Add Service";
const pagetitleUpdate = "Update Product";


export const tableColumns = [
    {
      name: "id",
      selector: (row) => row.proId,
      sortable: false,
      hide : "lg",
      omit : true,

    },
    {
        name: "name",
        selector: (row) => row.proName,
        sortable: true,                        
    },
    {
        name: "status",
        selector: (row) => {
            let currStatus = row.status;
            if(currStatus == 1) {return "On"} else { return "Off"}},
        sortable: true,                        
    },
    {
        name: "Date Modified",
        selector: (row) => new Date(row.date_modified).toLocaleString(),
        sortable: true,                
    },
    {
        name: "Date Created",
        selector: (row) => new Date(row.date_created).toLocaleString(),
        sortable: true,                
    },
    {
        name: "",
        Button:true,              
        cell: (row) => (                 
            <>
            <Icon name="edit-fill"></Icon>Edit
            </>           
        ),
        sortable: false,      
    },
]



const ProductSettings = () => {

    const api = useApiClient();

    const dataFetchedRef = useRef(false);
    const [DatatoUse, setData] = useState(null);
    const [error, setError] = useState(null);
  
    const modalForm = useRef(null);
    const modalFormAdd = useRef(null);
    const [selectedData, setSelectedData] = useState([]);
    const [previewModal, setPreviewModal] = useState(false);
    const [AddModal, setAddModal] = useState(false);
    
    

    useEffect(()=> {

        if (dataFetchedRef.current) return;
        dataFetchedRef.current = true;

        api.get(baseURL)        
        .then((Response)=>{
            setData(Response.data);
        }).catch(error => {
            setError(error);     
            console.log({error})
        });

    },[])

    if (error) 
        {      
          if(error.message.indexOf("status code 401")){
            return <Navigate to="/auths/auth-login" />
          } else
          return "Error: ${error.message}";
        }
    
        if(!DatatoUse) return(
            <Layout title="Clients" content="container"><Spinner animation="border" variant="primary" /></Layout>
        );

function detailSelect(obj){

    console.log(obj);

    const currentData = {...selectedData,
    proId:obj.proId,
    proName:obj.proName,
    proDesc:obj.proDesc,
    status:obj.status,
    date_created: obj.date_created,
    date_modified: obj.date_modified
    }

    setSelectedData(currentData)
    setPreviewModal(true)

    }



function closePreviewModal(){
    setPreviewModal(false);
    } 

function closeAddModal(){
    setAddModal(false);
    } 

function openAddModel(){
    setAddModal(true);
    } 
    

function openDeleteModal(){

    const frmFormData = new FormData();
    const sURL = "HMCareSettings/deleteproduct/"+selectedData.proId;

    api.post(sURL,frmFormData)
    .then((Response)=>{

        if(Response.data==true){      
        const updatedDataList = DatatoUse.filter((item) => item.proId !== selectedData.proId)
        setData(updatedDataList);
        }                          
    }).catch(error => {
        setError(error);     
        console.log({error})
    });

    setPreviewModal(false);

    }   

function openEditModal(){
    //setPreviewModal(false);
    }   


const updateState = (updatedData) => {

    const newState = DatatoUse.map(obj => {
        // 👇️ if id equals 2, update country property
        if (obj.proId === updatedData.proId) {
        return {...obj, 
            proName: updatedData.proName,
            proDesc: updatedData.proDesc,
            status:updatedData.status            
        };
        }

        // 👇️ otherwise return the object as is
        return obj;
    });
    
    setData(newState);
    
    };


    function handleFormSubmit(event){

        event.preventDefault();
        let newName = modalForm.current.querySelector('#dataname').value;
        let newstatus = modalForm.current.querySelector('#datastatus').value;
        let newDesc = modalForm.current.querySelector('#datadesc').value;
        console.log(newName);
        
        const frmFormData = new FormData();
        frmFormData.append("proId", selectedData.proId) 
        frmFormData.append("proName", newName) 
        frmFormData.append("proDesc", newDesc) 
        frmFormData.append("status", newstatus) 
        
        const sURL = "HMCareSettings/updateproduct/";

        api.post(sURL,frmFormData)
        .then((Response)=>{

            let updatedDataObj = Response.data;            
            updateState(updatedDataObj)
            
        }).catch(error => {
            setError(error);     
            console.log({error})
        });

        setPreviewModal(false);

    }   


    function handleAddFormSubmit(event){

        event.preventDefault();
        let newName = modalForm.current.querySelector('#dataname').value;
        let newstatus = modalForm.current.querySelector('#datastatus').value;
        let newDesc = modalForm.current.querySelector('#datadesc').value;

        

        //console.log(newstatus);
        
        const frmFormData = new FormData();            
        frmFormData.append("status", newstatus ) 
        frmFormData.append("proName", newName) 
        frmFormData.append("proDesc", newDesc) 
        
        
        const sURL = "HMCareSettings/addproduct/";

        api.post(sURL,frmFormData)
        .then((Response)=>{

            let updatedDataObj = Response.data;            

            const UpdateList = [{
                proId : updatedDataObj.proId,
                proName : updatedDataObj.proName,
                proDesc : updatedDataObj.proDesc,
                status : updatedDataObj.status,
                date_created : updatedDataObj.date_created,
                date_modified : updatedDataObj.date_modified,
            },...DatatoUse]    

            //console.log(UpdateList)

            setData(UpdateList)    

            
        }).catch(error => {
            setError(error);     
            console.log({error})
        });

        setAddModal(false);

    }   



  return (

    <>
    <Layout title="HMCarePlanner - Settings" content="container">
            
    <Block.Head page className="wide-md">
        <Block.HeadContent>
            <Block.Title>{pagetitle}</Block.Title>
            <Block.Text>Manage {pagetitle} settings</Block.Text>           
        </Block.HeadContent>
      </Block.Head>
    <BlockHead page>
    {/* <Alert variant="primary">
        <h2>{pagetitle}</h2>
    </Alert> */}
                <BlockHeadBetween>
                    <BlockHeadContent>
                    {error && 
                    <Alert variant="danger">
                        {error}
                    </Alert>
                    }        
                </BlockHeadContent>
               

      <BlockHeadContent tools>      
      <Button variant="outline-primary" action="add" onClick={openAddModel}>
        <Icon name="plus"></Icon><span>{pagetitleAddNew}</span>
    </Button>
</BlockHeadContent> </BlockHeadBetween>
                
            </BlockHead>
        <DataTable 
            tableClassName="data-table-head-light table-responsive" 
            pointerOnHover={true} 
            data={DatatoUse}                     
            columns={tableColumns} 
            striped={true} 
            highlightOnHover={true}  
            filterFieldName="proName" 
            onRowClicked={(row,event)=>{ detailSelect(row) }}            
            //actions="export"             
        />
        
    </Layout>

<Modal show={previewModal} onHide={closePreviewModal}>
<Modal.Header closeButton>
  <Modal.Title className="event-title" as="h4">Modify {pagetitle} - {selectedData.name}(#{selectedData.proId})</Modal.Title>  
</Modal.Header>

<Form ref={modalForm} onSubmit={handleFormSubmit}>
<Modal.Body>
  <div>
    <Row className="g-3">       
        <Col xs="12">
            <Form.Group>
                <h6 className="overline-title">Name</h6>
                <div className="form-control-wrap">
                    <Form.Control id="dataname" type="text" defaultValue={selectedData.proName} placeholder="Value" />
                </div>
            </Form.Group>
        </Col>
        <Col xs="12">
            <Form.Group>
                <h6 className="overline-title">Description</h6>
                <div className="form-control-wrap">
                    <Form.Control id="datadesc" type="textarea" defaultValue={selectedData.proDesc} placeholder="Value" />
                </div>
            </Form.Group>
        </Col>
        {/* <Col xs="12">
            <h6 className="overline-title">description</h6>
            <p className="event-end small">{selectedData.proDesc} </p>
        </Col> */}
        {/* <Col xs="12">
            <h6 className="overline-title">Status</h6>
            <p className="event-end small">{selectedData.status} </p>
        </Col> */}
        <Col xs="6">
            {/* <Form.Label htmlFor="eventTitle">Status</Form.Label> */}
            <h6 className="overline-title">Status</h6>
            <Form.Select id="datastatus" aria-label="status">
                <option value="0">Off</option>               
                {selectedData.status==1 && 
                    <option selected value="1">On</option>
                }
                {selectedData.status==0 && 
                    <option value="1">On</option>
                }
                
                
            </Form.Select>
        </Col>

        <Col xs="12">
            <h6 className="overline-title">Date Created</h6>
            <p className="event-end small">{selectedData.date_created} </p>
        </Col>
        <Col xs="12">
            <h6 className="overline-title">Date Modified</h6>
            <p className="event-end small">{selectedData.date_modified} </p>
        </Col>        
    </Row>
  </div>
</Modal.Body>
<Modal.Footer>
    <Button variant="light" onClick={closePreviewModal}>Cancel</Button>        
    <Button variant="danger" onClick={openDeleteModal}>Delete</Button>    
    <Button variant="primary" type="submit">{pagetitleUpdate}</Button>
</Modal.Footer>
</Form>
</Modal>

<Modal show={AddModal} onHide={closeAddModal}>
<Modal.Header closeButton>
  <Modal.Title className="event-title" as="h4">{pagetitleAddNew}</Modal.Title>  
</Modal.Header>

<Form ref={modalForm} onSubmit={handleAddFormSubmit}>
<Modal.Body>
  <div>
    <Row className="g-3">       
        <Col xs="12">
            <Form.Group>
                <Form.Label htmlFor="eventTitle">Name</Form.Label>
                <div className="form-control-wrap">
                    <Form.Control id="dataname" type="text" defaultValue={''} placeholder="Value" />
                </div>
                <Form.Label htmlFor="Desc">Description</Form.Label>
                <div className="form-control-wrap">
                    <Form.Control id="datadesc" type="textarea" defaultValue={''} placeholder="Description" />
                </div>
                <Col xs="6">           
                    <h6 className="overline-title">Status</h6>
                    <Form.Select id="datastatus" aria-label="status">
                        <option value="0">Off</option>                                       
                        <option selected value="1">On</option>
                    </Form.Select>
                </Col>
            </Form.Group>
            
        </Col>        
    </Row>
  </div>
</Modal.Body>
<Modal.Footer>
    <Button variant="primary" type="submit">{pagetitleAddNew}</Button>
</Modal.Footer>
</Form>
</Modal>

</>
  )
}

export default ProductSettings